import React from "react";
import {
  FormControl,
  InputLabel,
  Select as MuiSelect,
  MenuItem,
  FormHelperText,
} from "@mui/material";

const CustomSelect = ({
  options,
  label,
  name,
  value,
  onChange,
  returnId = false,
  error = false,
  helperText,
  required = false,
  fullWidth = true,
  size = "small",
  placeholder,
  sx,
  variant = "outlined",
  disabled = false,
  errorMessage,
  ...rest
}) => {
  const handleChange = (event) => {
    const selectedValue = event.target.value;

    if (returnId) {
      // Find the option with the selected value and return its ID
      const selectedOption = options.find(
        (option) =>
          option.value === selectedValue || option.id === selectedValue
      );
      onChange(name, selectedOption ? selectedOption.id : selectedValue);
    } else {
      // Return the value directly
      onChange(name, selectedValue);
    }
  };

  const labelId = `${name}-label`;

  return (
    <FormControl
      fullWidth={fullWidth}
      size={size}
      error={error}
      required={required}
      variant={variant}
      sx={{
        background: "#fff",
        ...sx,
      }}
      disabled={disabled}
    >
      {label && <InputLabel id={labelId}>{label}</InputLabel>}
      <MuiSelect
        labelId={labelId}
        id={name}
        value={value || ""}
        label={label}
        onChange={handleChange}
        variant="outlined"
        displayEmpty={!!placeholder}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 200,
            },
          },
        }}
        {...rest}
      >
        {placeholder && (
          <MenuItem value="" disabled>
            {placeholder}
          </MenuItem>
        )}
        {options.map((option) => (
          <MenuItem key={option.id} value={returnId ? option.id : option.value}>
            {option.label}
          </MenuItem>
        ))}
      </MuiSelect>
      {errorMessage ? (
        <FormHelperText error>{errorMessage}</FormHelperText>
      ) : helperText ? (
        <FormHelperText>{helperText}</FormHelperText>
      ) : null}
    </FormControl>
  );
};

export default CustomSelect;
